export const emailRegex = new RegExp(/^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,63}\.[a-zA-Z]{2,}$/);
export const phoneNumberRegex = new RegExp(/^[0-9]{10}$/);
export const aadharNumberRegex = new RegExp(/^[0-9]{12}$/);
export const StringWithSpace = new RegExp(/^[a-zA-Z]+.[a-zA-Z ]+$/);
export const PercentRegex = new RegExp(/(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/);
export const numberRegex = new RegExp(/^[0-9]+$/);
export const rciRegex = new RegExp(/^[A-Za-z]{1}[0-9]{5}$/);
export const percentageRegex = new RegExp(/^(\d{1,2}(\.\d{1,2})?|100(\.0{1,2})?)$/);
export const programNameRegex = new RegExp(/^[^0-9 ]{1}([a-zA-Z ])+[a-zA-Z ]+$/);
export const programDescriptionRegex = new RegExp(/^[a-zA-Z0-9\s\S.,]+$/);
export const passwordRegex = /^.{0,16}$/;
export const weightRegex = /^[0-9]+(\.[0-9]+)?$/;
// export const userHeightRegex = new RegExp(/^(?:[3-9][0-9]{1,2}|1[0-9]{2}|200|300)$/);
//export const userHeightRegex = new RegExp(/^(?:[3-9][0-9]|[1-2][0-9]{2}|300)$/);
export const userHeightRegex = new RegExp(/^(?:[3-9][0-9](?:\.\d{1,2})?|[1-2][0-9]{2}(?:\.\d{1,2})?|300)$/);




